export const STRIPE_CLIENT_SECRET_REQUEST = "STRIPE_CLIENT_SECRET_REQUEST";
export const STRIPE_CLIENT_SECRET_SUCCESS = "STRIPE_CLIENT_SECRET_SUCCESS";
export const STRIPE_CLIENT_SECRET_FAIL = "STRIPE_CLIENT_SECRET_FAIL";
